
<div class="h-100 d-flex flex-column">
    <div class="d-flex max-w mb-3 justify-content-between" *ngIf="dataSource.data.length!=0">
        <div class="c-box d-flex">
            <div class="ps-3">
                <div class="c-dep small-text steel-blue">{{courseData.dep}}</div>
                <div class="d-flex align-items-center">
                    Exam Status
                    <div class="text-bold st-box ms-2 d-flex">
                        <span class="active badge-c d-box"
                            *ngIf="examResultInfo.is_att == 1 && examResultInfo.is_p == 1">Passed</span>
                        <span class="un-attend badge-c d-box"
                            *ngIf="examResultInfo.is_att == 1 && examResultInfo.is_p == 0">Failed</span>
                        <span class="un-attend badge-c d-box" *ngIf="examResultInfo.is_att==0">Un-Attended</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="ms-2" >
            <button mat-raised-button color="primary" class="auth-form-btn" type="submit"
                (click)="onResetExamClick()">{{"Redo Exam"}}</button>
        </div>
    </div>
    <div class="table-container flex-grow-1 mt-2" *ngIf="!isSpinnerLoading && (dataSource.data.length!=0)">
        <table class="mt-4 " mat-table [dataSource]="dataSource" matSort (matSortChange)="announceSortChange($event)"
            class="mat-elevation-z8 normal-td">
            <ng-container matColumnDef="no">
                <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number">
                    {{"No"|translate}}</th>
                <td mat-cell *matCellDef="let element; let i = index">{{i+1}}</td>
            </ng-container>
            <ng-container matColumnDef="title">
                <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"> {{"Exam Title"|translate}}</th>
                <td mat-cell *matCellDef="let element"> {{element.tit }} </td>
            </ng-container>
            <ng-container matColumnDef="total_que">
                <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"> {{"Total  Question"|translate}}</th>
                <td mat-cell *matCellDef="let element"> {{ element.t_m ? element.t_m : '-'
                    }} </td>
            </ng-container>
            <ng-container matColumnDef="right_answer">
                <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"> {{"Right  Answer"|translate}}</th>
                <td mat-cell *matCellDef="let element"> {{element.r_a}} </td>
            </ng-container>
            <ng-container matColumnDef="attend_date">
                <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"> {{"Attend Date"|translate}}</th>
                <td mat-cell *matCellDef="let element">{{ element.a_t | date:'dd/MM/yyyy' }} </td>
            </ng-container>
            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number">
                    {{"Status"|translate}}</th>
                <td mat-cell *matCellDef="let element">
                    <div class="st-box">
                        <span class="un-attend badge-c d-box" *ngIf="element.is_att == 0"> Unattended</span>
                        <span class="active badge-c d-box" *ngIf="element.is_p && element.is_att"> Passed </span>
                        <span class="un-attend badge-c d-box" *ngIf="!element.is_p && element.is_att"> Failed
                        </span>
                    </div>
                </td>
            </ng-container>
            <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef>Action</th>
                <td mat-cell *matCellDef="let element">
                    <button mat-raised-button color="primary" class="auth-form-btn manage-btn primary-btn" type="submit"
                        (click)="onAttendExam(element.e_i)"
                        *ngIf="element.is_att == 0 && element.isShowAttend == 1">
                        <i class="fas fa-pen pr-1"></i>  {{"Attend Exam"|translate}}
                    </button>
                    <button type="button" mat-raised-button class="auth-form-btn manage-btn primary-btn" color="primary"
                        *ngIf="element.is_att == 0 && element.isShowAttend == 0" (click)="onExamAlertPopup('')">
                        <i class="fas fa-pen pr-1"></i> Attend Exam
                    </button>
                    <div class="cursor-pointer" *ngIf="element.is_att != 0 && element.e_sht"
                        (click)="download(element.e_sht)">
                        <img src="assets/images/icons/exam_sheet_download.svg" class="img-fluid" alt="">
                    </div>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <div  *ngIf="dataSource.data.length==0">
            <p class="text-center mt-3">Sorry, No exam is set for this course.</p>
            <div class="mat-table__message">          
              <img src="assets/images/gifs/no_record_found.gif" class="img-fluid" alt="">
          </div>
        </div>
    </div>
    <div class="pagination-cont" *ngIf="dataSource.data.length!=0">
        <div class="show-item">  {{"COMMON.SIP" | translate}}
            <select class="form-control sel-op ms-2" (change)="onPageSizeChange($event)"
                [(ngModel)]="config.itemsPerPage">
                <option [value]="item" *ngFor="let item of pageSizeOptions">{{ item }}</option>
            </select>
        </div>
        <div class="page-c">
            <ngb-pagination [collectionSize]="count" [(page)]="config.currentPage" [pageSize]="config.itemsPerPage"
                [maxSize]="maxPaginationSize" (pageChange)="onPageChange($event)"></ngb-pagination>
        </div>
    </div>
    <div class="d-box" *ngIf="!isSpinnerLoading &&dataSource.data.length==0">
        <div class="n-c">
            <img src="assets/images/icons/sorry_ic.svg" class="img-fluid" alt="">
        </div>
        <div class="n-i text-semibold grey-2 mt-2">Sorry, course creator has not set any exam for this course.</div>
    </div>
    <div class="tab-content flex-grow-1 d-box" *ngIf="isSpinnerLoading" style="position: relative;">
        <div class="custom-loader"></div>
    </div>
</div>
